// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Announcement Management */
.announcement-page .dashboard-body {
  padding-bottom: 2rem;
}

.announcement-hero__icon {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: rgba(15, 118, 110, 0.25);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
}

.announcement-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.announcement-card {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.announcement-card__value {
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--text);
}

.announcement-card__label {
  font-size: 0.85rem;
  color: var(--text-muted);
}

.announcement-card--active .announcement-card__value {
  color: #16a34a;
}

.announcement-card--inactive .announcement-card__value {
  color: #dc2626;
}

.announcement-tabs {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
}

.announcement-tab {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.85rem 1.5rem;
  font-size: 0.95rem;
  font-weight: 600;
  font-family: inherit;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s;
}

.announcement-tab--create {
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #fff;
  box-shadow: 0 2px 8px rgba(15, 118, 110, 0.35);
}

.announcement-tab--create:hover {
  opacity: 0.95;
}

.announcement-tab--list {
  background: #f1f5f9;
  color: var(--text);
}

.announcement-tab--list:hover {
  background: #e2e8f0;
}

.announcement-tab--active.announcement-tab--create {
  box-shadow: 0 4px 12px rgba(15, 118, 110, 0.4);
}

.announcement-tab--active.announcement-tab--list {
  background: #0f766e;
  color: #fff;
}

.announcement-content {
  background: #fff;
  border-radius: 12px;
  border: 1px solid var(--border);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.announcement-section {
  padding: 1.5rem;
}

.announcement-section__title {
  margin: 0 0 1.25rem;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.announcement-section__title i {
  color: #0f766e;
}

.announcement-section__title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.announcement-section__title-row .announcement-section__title {
  margin: 0;
}

.announcement-form__group {
  margin-bottom: 1.25rem;
}

.announcement-form__group label {
  display: block;
  margin-bottom: 0.4rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text);
}

.announcement-form__group .required {
  color: #dc2626;
}

.announcement-form__group input,
.announcement-form__group select,
.announcement-form__group textarea {
  width: 100%;
  padding: 0.7rem 1rem;
  font-size: 0.9rem;
  font-family: inherit;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #fff;
  color: var(--text);
}

.announcement-form__group input:focus,
.announcement-form__group select:focus,
.announcement-form__group textarea:focus {
  outline: none;
  border-color: #0f766e;
}

.announcement-form__group textarea {
  resize: vertical;
  min-height: 140px;
}

.announcement-form__actions {
  margin-top: 1.5rem;
}

.announcement-btn--publish {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  font-size: 0.95rem;
  font-weight: 600;
  font-family: inherit;
  color: #fff;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  border: none;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(15, 118, 110, 0.35);
  transition: opacity 0.2s;
}

.announcement-btn--publish:hover {
  opacity: 0.95;
}

.announcement-btn--category {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.65rem 1rem;
  font-size: 0.88rem;
  font-weight: 600;
  font-family: inherit;
  color: #fff;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  border: none;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(15, 118, 110, 0.3);
}

.announcement-btn--category:hover {
  opacity: 0.95;
}

.announcement-table-wrap {
  overflow-x: auto;
}

.announcement-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.announcement-table th {
  padding: 0.9rem 1rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  background: #f8fafc;
  border-bottom: 2px solid #e2e8f0;
}

.announcement-table td {
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  color: var(--text);
}

.announcement-table tbody tr:nth-child(even) {
  background: #fafafa;
}

.announcement-table tbody tr:hover {
  background: #f8fafc !important;
}

.announcement-table__desc {
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.announcement-status {
  display: inline-block;
  padding: 0.3rem 0.6rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
}

.announcement-status--active {
  background: #dcfce7;
  color: #166534;
}

.announcement-status--inactive {
  background: #fef2f2;
  color: #b91c1c;
}

.announcement-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
}

.announcement-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.4rem 0.75rem;
  font-size: 0.8rem;
  font-weight: 600;
  font-family: inherit;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.1s;
}

.announcement-action-btn:hover {
  opacity: 0.9;
}

.announcement-action-btn--active {
  background: #dcfce7;
  color: #166534;
}

.announcement-action-btn--active:hover {
  background: #bbf7d0;
}

.announcement-action-btn--inactive {
  background: #fef2f2;
  color: #b91c1c;
}

.announcement-action-btn--inactive:hover {
  background: #fecaca;
}

.announcement-action-btn--delete {
  background: #1e293b;
  color: #fff;
}

.announcement-action-btn--delete:hover {
  background: #334155;
}

.announcement-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1200;
  padding: 1rem;
}

.announcement-modal {
  width: 100%;
  max-width: 520px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 16px 40px rgba(2, 6, 23, 0.28);
  overflow: hidden;
}

.announcement-modal__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #fff;
  padding: 1rem 1.25rem;
}

.announcement-modal__head h3 {
  margin: 0;
  font-size: 1rem;
}

.announcement-modal__close {
  border: none;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  font-size: 1.1rem;
}

.announcement-modal__body {
  padding: 1rem 1.25rem 1.2rem;
  display: grid;
  gap: 0.8rem;
}

.announcement-modal__body label {
  display: grid;
  gap: 0.35rem;
  font-size: 0.86rem;
  color: var(--text-muted);
}

.announcement-modal__body input,
.announcement-modal__body textarea {
  border: 1px solid var(--border);
  border-radius: 8px;
  font-family: inherit;
  font-size: 0.9rem;
  padding: 0.62rem 0.75rem;
}

.announcement-modal__body input:focus,
.announcement-modal__body textarea:focus {
  outline: none;
  border-color: #14b8a6;
}

.announcement-modal__actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.6rem;
}

.announcement-modal__actions button {
  border: none;
  border-radius: 8px;
  padding: 0.55rem 0.95rem;
  font-size: 0.86rem;
  font-weight: 600;
  cursor: pointer;
}

.announcement-modal__actions button[type="button"] {
  background: #e2e8f0;
  color: #0f172a;
}

.announcement-modal__actions button[type="submit"] {
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #fff;
}

.announcement-modal__actions button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.announcement-modal__msg {
  margin: 0;
  border-radius: 8px;
  padding: 0.55rem 0.7rem;
  font-size: 0.82rem;
}

.announcement-modal__msg--error {
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #b91c1c;
}

.announcement-modal__msg--success {
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  color: #047857;
}

@media (max-width: 768px) {
  .announcement-cards {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Exchange/AnnouncementManagementPage.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,8CAA8C;EAC9C,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6DAA6D;EAC7D,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oCAAoC;EACpC,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;;EAEE,+BAA+B;EAC/B,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Announcement Management */\n.announcement-page .dashboard-body {\n  padding-bottom: 2rem;\n}\n\n.announcement-hero__icon {\n  width: 52px;\n  height: 52px;\n  border-radius: 12px;\n  background: rgba(15, 118, 110, 0.25);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.4rem;\n}\n\n.announcement-cards {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.announcement-card {\n  background: #fff;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  padding: 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.announcement-card__value {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: var(--text);\n}\n\n.announcement-card__label {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n}\n\n.announcement-card--active .announcement-card__value {\n  color: #16a34a;\n}\n\n.announcement-card--inactive .announcement-card__value {\n  color: #dc2626;\n}\n\n.announcement-tabs {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n}\n\n.announcement-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.85rem 1.5rem;\n  font-size: 0.95rem;\n  font-weight: 600;\n  font-family: inherit;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.announcement-tab--create {\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  color: #fff;\n  box-shadow: 0 2px 8px rgba(15, 118, 110, 0.35);\n}\n\n.announcement-tab--create:hover {\n  opacity: 0.95;\n}\n\n.announcement-tab--list {\n  background: #f1f5f9;\n  color: var(--text);\n}\n\n.announcement-tab--list:hover {\n  background: #e2e8f0;\n}\n\n.announcement-tab--active.announcement-tab--create {\n  box-shadow: 0 4px 12px rgba(15, 118, 110, 0.4);\n}\n\n.announcement-tab--active.announcement-tab--list {\n  background: #0f766e;\n  color: #fff;\n}\n\n.announcement-content {\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  overflow: hidden;\n}\n\n.announcement-section {\n  padding: 1.5rem;\n}\n\n.announcement-section__title {\n  margin: 0 0 1.25rem;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.announcement-section__title i {\n  color: #0f766e;\n}\n\n.announcement-section__title-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n.announcement-section__title-row .announcement-section__title {\n  margin: 0;\n}\n\n.announcement-form__group {\n  margin-bottom: 1.25rem;\n}\n\n.announcement-form__group label {\n  display: block;\n  margin-bottom: 0.4rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text);\n}\n\n.announcement-form__group .required {\n  color: #dc2626;\n}\n\n.announcement-form__group input,\n.announcement-form__group select,\n.announcement-form__group textarea {\n  width: 100%;\n  padding: 0.7rem 1rem;\n  font-size: 0.9rem;\n  font-family: inherit;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text);\n}\n\n.announcement-form__group input:focus,\n.announcement-form__group select:focus,\n.announcement-form__group textarea:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.announcement-form__group textarea {\n  resize: vertical;\n  min-height: 140px;\n}\n\n.announcement-form__actions {\n  margin-top: 1.5rem;\n}\n\n.announcement-btn--publish {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.5rem;\n  font-size: 0.95rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: #fff;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(15, 118, 110, 0.35);\n  transition: opacity 0.2s;\n}\n\n.announcement-btn--publish:hover {\n  opacity: 0.95;\n}\n\n.announcement-btn--category {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.65rem 1rem;\n  font-size: 0.88rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: #fff;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(15, 118, 110, 0.3);\n}\n\n.announcement-btn--category:hover {\n  opacity: 0.95;\n}\n\n.announcement-table-wrap {\n  overflow-x: auto;\n}\n\n.announcement-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.announcement-table th {\n  padding: 0.9rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.68rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #64748b;\n  background: #f8fafc;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.announcement-table td {\n  padding: 0.9rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n  color: var(--text);\n}\n\n.announcement-table tbody tr:nth-child(even) {\n  background: #fafafa;\n}\n\n.announcement-table tbody tr:hover {\n  background: #f8fafc !important;\n}\n\n.announcement-table__desc {\n  max-width: 280px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.announcement-status {\n  display: inline-block;\n  padding: 0.3rem 0.6rem;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.announcement-status--active {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.announcement-status--inactive {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.announcement-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.announcement-action-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.4rem 0.75rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  font-family: inherit;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: opacity 0.2s, transform 0.1s;\n}\n\n.announcement-action-btn:hover {\n  opacity: 0.9;\n}\n\n.announcement-action-btn--active {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.announcement-action-btn--active:hover {\n  background: #bbf7d0;\n}\n\n.announcement-action-btn--inactive {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.announcement-action-btn--inactive:hover {\n  background: #fecaca;\n}\n\n.announcement-action-btn--delete {\n  background: #1e293b;\n  color: #fff;\n}\n\n.announcement-action-btn--delete:hover {\n  background: #334155;\n}\n\n.announcement-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1200;\n  padding: 1rem;\n}\n\n.announcement-modal {\n  width: 100%;\n  max-width: 520px;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 16px 40px rgba(2, 6, 23, 0.28);\n  overflow: hidden;\n}\n\n.announcement-modal__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  color: #fff;\n  padding: 1rem 1.25rem;\n}\n\n.announcement-modal__head h3 {\n  margin: 0;\n  font-size: 1rem;\n}\n\n.announcement-modal__close {\n  border: none;\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  cursor: pointer;\n  background: rgba(255, 255, 255, 0.2);\n  color: #fff;\n  font-size: 1.1rem;\n}\n\n.announcement-modal__body {\n  padding: 1rem 1.25rem 1.2rem;\n  display: grid;\n  gap: 0.8rem;\n}\n\n.announcement-modal__body label {\n  display: grid;\n  gap: 0.35rem;\n  font-size: 0.86rem;\n  color: var(--text-muted);\n}\n\n.announcement-modal__body input,\n.announcement-modal__body textarea {\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 0.9rem;\n  padding: 0.62rem 0.75rem;\n}\n\n.announcement-modal__body input:focus,\n.announcement-modal__body textarea:focus {\n  outline: none;\n  border-color: #14b8a6;\n}\n\n.announcement-modal__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.6rem;\n}\n\n.announcement-modal__actions button {\n  border: none;\n  border-radius: 8px;\n  padding: 0.55rem 0.95rem;\n  font-size: 0.86rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.announcement-modal__actions button[type=\"button\"] {\n  background: #e2e8f0;\n  color: #0f172a;\n}\n\n.announcement-modal__actions button[type=\"submit\"] {\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  color: #fff;\n}\n\n.announcement-modal__actions button:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.announcement-modal__msg {\n  margin: 0;\n  border-radius: 8px;\n  padding: 0.55rem 0.7rem;\n  font-size: 0.82rem;\n}\n\n.announcement-modal__msg--error {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  color: #b91c1c;\n}\n\n.announcement-modal__msg--success {\n  background: #ecfdf5;\n  border: 1px solid #a7f3d0;\n  color: #047857;\n}\n\n@media (max-width: 768px) {\n  .announcement-cards {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
